import { ActivitySpinnerSize, ActivitySpinnerWidget, ChromeTooltipWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { imgPath } from '../../common/utilities/ImgUrl';
import { cssClass } from '../../style';
import { FieldConceptIndexingStatusCode } from '../../ts/ServerApi/requests/GetFieldConceptIndexingStatus';

const cssPrefix = 'DataroleStatusMetadata';
const leftPositionedImage = cssClass(cssPrefix, 'leftPositionedImage', {verticalAlign: 'sub', marginRight: CommonStyles.Sizes.DefaultSpace});
const metadataContainer = cssClass(cssPrefix, 'container', { marginLeft: TabStyles.Spacing.ExtraLargeSpace});
const errorBox =  cssClass(cssPrefix, 'errorBox', {color: CommonStyles.Colors.HyperlinkBlue, backgroundColor: '#D7ECF9', padding: CommonStyles.Sizes.DefaultSpace, paddingRight: CommonStyles.Sizes.LargeSpace});

export const DataRoleStatusMetadata = (fieldConceptIndexingStatusCode: FieldConceptIndexingStatusCode): JSX.Element | null => {
  switch(fieldConceptIndexingStatusCode){
    case 'INDEXING_FAILED_RETRY_PENDING':
    case 'INDEXING_FAILED':
      return <span className={metadataContainer}>
      <ChromeTooltipWidget
        width={300}
        getContent={() => Promise.resolve(<ErrorTooltipContent/>)}
        >
          <span className={errorBox}>
            <img src={imgPath('Spaces_Data_Status.svg')} className={leftPositionedImage}/>
            {Messages.dataRoleHeaderMessage_Error()}
          </span>
        </ChromeTooltipWidget>
      </span>;
    case 'INDEXING_IN_PROGRESS':
    case 'INDEXING_PENDING':
    case 'INDEXING_FAILED_RETRY_PENDING':
      return <span className={metadataContainer}>
        <span className={leftPositionedImage}>
          <ActivitySpinnerWidget spinnerSize={ActivitySpinnerSize.Small} testId={'datarole-status'}/>
        </span>
        <span style={{color: '#9B9B9B'}}>
          {Messages.dataRoleHeaderMessage_Loading()}
        </span>
      </span>;
    default:
      return null;
  }
};

const ErrorTooltipContent: React.FC = () => (
  <div>
    <div>
      <span style={{color: CommonStyles.Colors.HyperlinkBlue, padding: CommonStyles.Sizes.DefaultSpace}}>
        <img src={imgPath('Spaces_Data_Status.svg')} className={leftPositionedImage}/>
        {Messages.dataRoleHeaderMessage_Error_NotOperational()}
      </span>
    </div>
    <div style={{padding: CommonStyles.Sizes.DefaultSpace}}>
      {Messages.dataRoleHeaderMessage_Error_ErrorMessage()}
    </div>
  </div>
);
